import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Meeting booking: store + meeting type + the chosen slot's time/duration/tz. */
export class MeetingIntentBuilder extends StoreScopedIntentBuilder {
  /** The meeting type id from the seller's availability config. */
  meetingType(meetingTypeId: string): this {
    this.root.param('meeting_type', meetingTypeId);
    return this;
  }

  /** ISO-8601 start time of the chosen slot. */
  time(isoStartTime: string): this {
    this.root.param('meeting_time', isoStartTime);
    return this;
  }

  /** Duration in minutes. */
  duration(minutes: number): this {
    this.root.param('meeting_duration', minutes);
    return this;
  }

  /** IANA timezone the slot is expressed in. */
  timezone(ianaTz: string): this {
    this.root.param('meeting_tz', ianaTz);
    return this;
  }
}
